var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0833 24.75V22.0833C22.0833 20.6688 21.5214 19.3123 20.5212 18.3121C19.521 17.3119 18.1645 16.75 16.75 16.75H6.08333C4.66885 16.75 3.31229 17.3119 2.3121 18.3121C1.3119 19.3123 0.75 20.6688 0.75 22.0833V24.75M16.75 6.08333C16.75 9.02885 14.3622 11.4167 11.4167 11.4167C8.47115 11.4167 6.08333 9.02885 6.08333 6.08333C6.08333 3.13781 8.47115 0.75 11.4167 0.75C14.3622 0.75 16.75 3.13781 16.75 6.08333Z",
    stroke: "black",
    strokeOpacity: 0.3,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.30eca65d9a2ad46d68b9f81fbdc70a95.svg";
export { ForwardRef as ReactComponent };